import type { IconSvgObject } from './types';

const ReceiptJapaneseYenIcon: IconSvgObject = [
  ["path", { d: "M9 8C9.2 8.9167 10.08 10.5 12 11.5M12 11.5C13.92 10.5 14.8 8.9167 15 8M12 11.5V17.0002M14.5 13.6827H9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9.5 2L12 3.5L14.5 2L17 3.5L20 2V22L17 20.5L14.5 22L12 20.5L9.5 22L7 20.5L4 22V2L7 3.5L9.5 2Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ReceiptJapaneseYenIcon;
